import { getSelectedLocale } from './Localization';

export const formatCurrency = (amount: number): string => {
  const formatter = new Intl.NumberFormat(getSelectedLocale(), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${formatter.format(amount)} TL`;
};

export const applyRatio = (amount: number, ratio: number): number =>
  (amount * (100 + ratio)) / 100;
